import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const tabs = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;

  &:after {
    content: "";
    height: 1px;
    width: 100%;
    margin-bottom: 20px;
    background-color: ${colors.gray.light};
  }
`;
